import ScrollReveal from 'scrollreveal';

const isSSR = typeof window === 'undefined';
const sr = isSSR ? null : ScrollReveal();

if (sr && typeof window !== 'undefined') {
  try {
    const originalStore = sr.store;

    const storeProxy = new Proxy(originalStore, {
      get(target, prop, receiver) {
        if (prop === 'containers') {
          const containers = target.containers;
          return new Proxy(containers, {
            get(cTarget, cProp, cReceiver) {
              const container = Reflect.get(cTarget, cProp, cReceiver);
              if (container && container.node && !container.geometry) {
                try {
                  const isDocEl = container.node === document.documentElement;
                  const height = isDocEl
                    ? container.node.clientHeight
                    : container.node.offsetHeight;
                  const width = isDocEl ? container.node.clientWidth : container.node.offsetWidth;

                  let offsetTop = 0;
                  let offsetLeft = 0;
                  let node = container.node;

                  while (node) {
                    if (!isNaN(node.offsetTop)) {
                      offsetTop += node.offsetTop;
                    }
                    if (!isNaN(node.offsetLeft)) {
                      offsetLeft += node.offsetLeft;
                    }
                    node = node.offsetParent;
                  }

                  container.geometry = {
                    bounds: {
                      top: offsetTop,
                      right: offsetLeft + width,
                      bottom: offsetTop + height,
                      left: offsetLeft,
                    },
                    height,
                    width,
                  };
                } catch (e) {
                  // ignore geometry calculations failures
                }
              }
              return container;
            },
          });
        }

        if (prop === 'elements') {
          const elements = target.elements;
          return new Proxy(elements, {
            get(eTarget, eProp, eReceiver) {
              const element = Reflect.get(eTarget, eProp, eReceiver);
              if (element && element.node && !element.geometry) {
                try {
                  const height = element.node.offsetHeight;
                  const width = element.node.offsetWidth;

                  let offsetTop = 0;
                  let offsetLeft = 0;
                  let node = element.node;

                  while (node) {
                    if (!isNaN(node.offsetTop)) {
                      offsetTop += node.offsetTop;
                    }
                    if (!isNaN(node.offsetLeft)) {
                      offsetLeft += node.offsetLeft;
                    }
                    node = node.offsetParent;
                  }

                  element.geometry = {
                    bounds: {
                      top: offsetTop,
                      right: offsetLeft + width,
                      bottom: offsetTop + height,
                      left: offsetLeft,
                    },
                    height,
                    width,
                  };
                } catch (e) {
                  // ignore element geometry calculation failures
                }
              }
              return element;
            },
          });
        }

        return Reflect.get(target, prop, receiver);
      },
    });

    sr.store = storeProxy;
  } catch (err) {
    console.error('Failed to proxy ScrollReveal store:', err);
  }
}

export default sr;
